<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3 style="margin: 0px">
          {{ $t("productPackaging") }}
        </h3>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-1 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
    <DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import twoInfoButtonsDynamic from "../CellRenderers/twoInfoButtonsDynamic.vue";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import TextViewCellRenderer from "../CellRenderers/TextViewCellRenderer.vue";
import moment from "moment";
export default {
  components: { AgGridVue, twoInfoButtonsDynamic, DeleteWarning, TextViewCellRenderer },
  data() {
    return {
      deleteData: [{}],
      deleteWarningPromptValid: false,
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  methods: {
    addOrderCollectData() {
      const vs = this.$vs;
      let args = {
        companyId: "",
        collectionIsDone: true,
      };
      this.$store
        .dispatch("order/listOrderCollectHead", args)
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else if (response.status == 400) {
            this.$store.commit("ORDER_COLLECT_HEAD", []);
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getOrderCollectList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 110,
          pinned: "left",
          cellRendererFramework: "twoInfoButtonsDynamic",
          cellRendererParams: {
            detailMethodsOne: "getCollectionDetail",
            tooltipOne: this.$t("Collect"),
            iconDetailOne: "material-symbols:action-key",
            iconColorOne: "#065a82",

            detailMethodsTwo: "deleteCollection",
            tooltipTwo: this.$t("Delete"),
            iconDetailTwo: "ic:baseline-remove-circle",
            iconColorTwo: "#fe6d73",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val == "CollectionDone" || val == "CollectionPackageDone") {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (val.toString().includes("Id") == false) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    deleteCollection() {
      this.deleteWarningPromptValid = true;
    },
    closeDeleteWarning() {
      this.deleteWarningPromptValid = false;
    },
    getCollectionDetail(data) {
      this.$router.push({
        name: "product-packaging-product-scan",
        params: { collection: data.CollectionCode, marketplace: data.CompanyInfoId },
      });
    },
    deleteSubmit(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("order/deleteOrderCollect", data.OrderNumber)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.addOrderCollectData();
              this.deleteWarningPromptValid = false;
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
  },
  computed: {
    orderCollectHead: {
      get() {
        return this.$store.state.order.OrderCollectHead;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  watch: {
    orderCollectHead(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getOrderCollectList();
      }
      return val;
    },
  },
  created() {
    this.addOrderCollectData();
  },
  mounted() {
    this.$root.$on("getCollectionDetail", (data) => {
      this.getCollectionDetail(data);
    });
    this.$root.$on("deleteCollection", (data) => {
      this.deleteData = data;
      this.deleteCollection(data);
    });
    this.$root.$on("closeDeleteWarning", () => {
      this.closeDeleteWarning();
    });
    this.$root.$on("deleteSubmit", (data) => {
      this.deleteSubmit(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("getCollectionDetail");
    this.$root.$off("deleteCollection");
    this.$root.$off("closeDeleteWarning");
    this.$root.$off("deleteSubmit");
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 140px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
